export default __webpack_public_path__ + "0ea92697ad052cf3579eaaeb2137048d.png";